<template lang="pug">
div
  AlgoliaWrapper(:search-context='$algolia.searchContexts.salesReps')
    div(class='px-3 bg-gray-lighter')
      div(class='lg:container py-8')
        h1(class='text-center mt-0') Sales Representative Contact Info

        div(class='mx-auto w-full lg:max-w-md text-center')
          SalesContactStateSelector

    div(class='px-3 py-6 lg:py-8')
      div(class='lg:container')
        AlgoliaResults
          template(#results='{ results }')
            div(class='space-y-6')
              template(v-for='result in results' :key='result.objectID')
                SalesContactRep(:sales-rep='result')
</template>

<script>
export default defineNuxtComponent({
  name: 'SalesContact',
  setup() {
    const { $sitewideConfig } = useNuxtApp()
    const { translateTemplate } = useTemplateTranslator()

    // 404 if sales reps are not enabled
    if (!$sitewideConfig.config.salesRepsSearchEnabled)
      throw createError({ statusCode: 404, statusMessage: 'Invalid URL', fatal })

    useMetaTags({
      title: translateTemplate('Sales Contacts [TITLE_SUFFIX]'),
    })
  },
})
</script>
